import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import NewDashboardContent from "../components/NewDashboardContent/NewDashboardContent";
import {
  getAccountOverviewInformation,
  getNewDashboardInformation,
  getTransferFundsGoal,
  getUserAccountDetails,
  resetNewDashboardInformation,
  resetQA,
  setFirstLogin,
  getBenchmarkData,
} from "../redux/actions";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const BodyWrapper = styled.div`
  padding: 30px 70px;

  @media (max-width: 480px) {
    padding: 10px 30px 30px 30px;
  }
`;

const NewDashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    newDashboardData,
    transferGoals,
    userAccountDetails,
    accountOverview,
    loading,
    isFirstLogin,
  } = useSelector((state) => state.user);
  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    if (newDashboardData) {
      if (isFirstLogin && newDashboardData?.length === 0) {
        dispatch(setFirstLogin(false));
        history.push("/goal-picker");
      } else {
        dispatch(setFirstLogin(false));
      }
    }
  }, [dispatch, history, isFirstLogin, newDashboardData]);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  useEffect(() => {
    dispatch(getUserAccountDetails());
    dispatch(resetQA(null));
    dispatch(getNewDashboardInformation());
    dispatch(getTransferFundsGoal());
    dispatch(getAccountOverviewInformation());
    dispatch(getBenchmarkData());
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
  }, [dispatch]);

  useEffect(() => {
    if (
      newDashboardData &&
      transferGoals &&
      userAccountDetails &&
      accountOverview
    ) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [
    dispatch,
    userAccountDetails,
    newDashboardData,
    transferGoals,
    accountOverview,
  ]);

  useEffect(() => {
    return () => {
      dispatch(resetNewDashboardInformation());
    };
  }, [dispatch]);

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      {newDashboardData && accountOverview && (
        <>
          <HeaderWithoutLogin
            isLogOutButtonVisible={true}
            isHelpButtonVisible={true}
          />
          <BodyWrapper>
            <NewDashboardContent
              newDashboardData={newDashboardData}
              transferGoals={transferGoals}
            />
          </BodyWrapper>
        </>
      )}
    </>
  );
};

export default NewDashboard;
